import { useEffect, useState } from 'react';

function read(): number {
  const ratio = window.devicePixelRatio;
  return Number.isFinite(ratio) && ratio > 0 ? ratio : 1;
}

/**
 * Effective renderer pixel ratio. Page zoom and moving the window between
 * displays both change it without remounting, and neither reliably fires
 * `resize` alone — hence the resolution media query.
 */
export function useDevicePixelRatio(): number {
  const [ratio, setRatio] = useState(read);

  useEffect(() => {
    let query: MediaQueryList | null = null;

    const update = () => {
      query?.removeEventListener('change', update);

      const next = read();
      setRatio((current) => (current === next ? current : next));

      query = typeof window.matchMedia === 'function'
        ? window.matchMedia(`(resolution: ${next}dppx)`)
        : null;
      query?.addEventListener('change', update);
    };

    window.addEventListener('resize', update);
    update();

    return () => {
      query?.removeEventListener('change', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return ratio;
}
